import React, { useState, useEffect } from 'react'
import httpClient from '../components/helpers/httpClient'
import './MobileLoginPage.css'
import { useNavigate, useSearchParams, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from "react-toastify"
import logo_white from "../assets/logos/Logo-Vitruvi-transparant_Wit.png"

export default function MobileResetPasswordPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    if (!token) {
      toast.error("Invalid reset link. Please request a new password reset.")
      navigate("/forgotpassword")
    }
  }, [token, navigate])

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!password) {
      toast.error("Please enter a new password")
      return
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long")
      return
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match")
      return
    }

    if (!token) {
      toast.error("Invalid reset token")
      return
    }

    setLoading(true)

    try {
      const data = { token, new_password: password }
      await httpClient.post(import.meta.env.VITE_API_URL + "/api/admin/reset-password-confirm", data)
      
      setSuccess(true)
      toast.success("Password has been reset successfully")
      
      // Redirect to login after 2 seconds
      setTimeout(() => {
        navigate("/")
      }, 2000)
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.error || "Invalid or expired reset token")
        if (error.response.data.error?.includes("expired")) {
          setTimeout(() => {
            navigate("/forgotpassword")
          }, 2000)
        }
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }

    setLoading(false)
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit(event)
    }
  }

  if (!token) {
    return null
  }

  if (success) {
    return (
      <div className="mobile-login-page">
        <div className="mobile-login-container">
          <img src={logo_white} alt="Vitruvi logo" className="mobile-login-logo" />
          <div className="mobile-login-form">
            <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '20px', fontSize: '20px' }}>Password Reset Successful</h2>
            <p style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', fontSize: '14px' }}>
              Your password has been reset successfully. Redirecting to login...
            </p>
            <div className="mobile-login-footer">
              <Link to="/">Go to Login</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="mobile-login-page">
      <div className="mobile-login-container">
        <img src={logo_white} alt="Vitruvi logo" className="mobile-login-logo" />
        <div className="mobile-login-form">
          <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '20px', fontSize: '20px' }}>Reset Password</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', marginBottom: '20px', fontSize: '14px' }}>
            Enter your new password below.
          </p>
          <div className="mobile-input-group">
            <input
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder='NEW PASSWORD'
              onKeyDown={handleEnter}
              className="mobile-login-input"
              type="password"
              disabled={loading}
            />
          </div>
          <div className="mobile-input-group">
            <input
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder='CONFIRM PASSWORD'
              onKeyDown={handleEnter}
              className="mobile-login-input"
              type="password"
              disabled={loading}
            />
          </div>

          <button 
            type='button' 
            className='mobile-login-button' 
            onClick={handleSubmit} 
            disabled={loading}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : "RESET PASSWORD"}
          </button>
          
          <div className="mobile-login-footer">
            <Link to='/'>Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

